export default "__VITE_ASSET__C$SsSCGq__"